export enum InputStyles {
  Outlined = 'outlined',
  Material = 'material',
}
